import { mapGetters } from "vuex";
import { profile } from "../../services/api";

export const userMixin = {
  computed: {
    ...mapGetters({
      hasUser: "user/hasUser",
      getUser: "user/getUser"
    })
  },
  methods: {
    async fetchAndUpdateUser() {
      const result = await profile();
      if (result.status == 200) {
        const user = result.data;
        return this.$store.dispatch("user/updateUser", user);
      } else {
        // console.log("Error in fetching user");
      }
    },
    logoutUser() {
      return this.$store.dispatch("user/logoutUser");
    }
  }
};
